import React from 'react';
import { get } from 'lodash';

// React view component to render
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { memberDetailCommunicationHistoryWidget as MemberDetailCommunicationHistoryWidget} from 'ui/views/widgets/memberDetailCommunicationHistoryWidget';
import { MemberDetailsCommunicationHistoryWidgetService } from 'services/memberDetailsCommunicationHistoryWidget';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberDetailsCommunicationHistoryWidget } from 'ui/containers/MemberDetailsCommunicationHistoryWidget';
 *
 * // render
 * <MemberDetailsCommunicationHistoryWidget propName='propValue'/>
 */
export class MemberDetailsCommunicationHistoryWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
        this.fetchGeneration = 0;
        this.fetchActive = true;

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // Member Detail instance
        this.memberDetailsCommunicationHistoryWidgetService = new MemberDetailsCommunicationHistoryWidgetService();

        // start member detail data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch member detail information.
     */
    async fetchComponentData() {
       
        log.debug( 'MemberDetailsCommunicationHistoryWidgetService.memberDetailsCommunicationHistoryWidgetService()' );

        const generation = ++this.fetchGeneration;
        // cancel ongoing request
        this.memberDetailsCommunicationHistoryWidgetService.cancel();

        try {
            const { status, data }  = await this.memberDetailsCommunicationHistoryWidgetService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            if( ! this.fetchActive || generation !== this.fetchGeneration ) return;

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } ) : null );
            } else {
                this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } ) : null );
            }

        } catch( e ) {
            if( ! this.fetchActive || generation !== this.fetchGeneration ) return;
            this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } ) : null );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.fetchActive = false;
        this.fetchGeneration++;
        this.memberDetailsCommunicationHistoryWidgetService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberDetailCommunicationHistoryWidget
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
            />
        );
    }
}

// set display name
MemberDetailsCommunicationHistoryWidget.displayName = 'MemberDetailsCommunicationHistoryWidget';

// set default props
MemberDetailsCommunicationHistoryWidget.defaultProps = {
    requestPayload: {},
};

// prop types
MemberDetailsCommunicationHistoryWidget.propTypes = {};
